export default __webpack_public_path__ + "static/media/gnl2.a9407e8f.jpg";